<mat-form-field appearance="outline" class="w-50" subscriptSizing="dynamic">
    <mat-label class="no-brand">filter</mat-label>
    <mat-icon class="material-icons-outlined" matPrefix>filter_alt</mat-icon>
    <input matInput type="text" (keyup)="onInputKeyUp($event)" class="filter-box">
</mat-form-field>